import styled from 'styled-components';
import themeGet from '@styled-system/theme-get';

import Image from '../../../Core/Image';
import Container from '../../../Core/Container';

export const StyledContainer = styled(Container)`
  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    width: 100%;
  }
`;

export const ImageWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
  max-height: 320px;
`;

export const Img = styled(Image)`
  max-width: 100%;
  object-fit: cover;
`;
